const PARALLAX_SELECTOR = '[data-element-parallax]';
const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

let parallaxElements = [];
let frameRequested = false;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function collectParallaxElements() {
  parallaxElements = Array.from(document.querySelectorAll(PARALLAX_SELECTOR));
  updateParallax();
}

function updateParallax() {
  frameRequested = false;

  if (reduceMotionQuery.matches) {
    parallaxElements.forEach((element) => {
      element.style.setProperty('--element-parallax-offset', '0px');
    });
    return;
  }

  const viewportHeight = window.innerHeight || 1;

  parallaxElements.forEach((element) => {
    const rect = element.getBoundingClientRect();
    const strength = Number.parseFloat(element.dataset.parallaxStrength || '24');
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = viewportHeight / 2;
    const normalizedDistance = (elementCenter - viewportCenter) / viewportHeight;
    const offset = clamp(normalizedDistance * -strength, -strength, strength);

    element.style.setProperty('--element-parallax-offset', `${offset.toFixed(2)}px`);
  });
}

function requestParallaxUpdate() {
  if (frameRequested) {
    return;
  }

  frameRequested = true;
  window.requestAnimationFrame(updateParallax);
}

document.addEventListener('DOMContentLoaded', collectParallaxElements);
window.addEventListener('load', collectParallaxElements);
window.addEventListener('resize', requestParallaxUpdate);
document.addEventListener('scroll', requestParallaxUpdate, { passive: true });
document.addEventListener('shopify:section:load', collectParallaxElements);

if (typeof reduceMotionQuery.addEventListener === 'function') {
  reduceMotionQuery.addEventListener('change', collectParallaxElements);
} else if (typeof reduceMotionQuery.addListener === 'function') {
  reduceMotionQuery.addListener(collectParallaxElements);
}
